<template>
  <div>
    <img class="bg" alt :src='image' />
    <img class='logo' alt src='../assets/logo-qiw.png' />
  </div>
</template>

<script>
  export default {
    props: {
      image: {
        type: String,
        require: true,
      }
    },
  }
</script>

<style scoped>
  div {
    width: 100vw;
    height: 15vw;
    position: relative;
    overflow: hidden;
  }

  .bg {
    display: inline-block;
    width: 100%;
  }

  .logo {
    width: 50px;
    height: 23px;
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 17px;
    transform: translateY(-50%);
  }
</style>